import { useState, useEffect } from "react";

const BREAKPOINTS = {
  LG: 991.95,
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.LG);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= BREAKPOINTS.LG);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};
